import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { from } from 'rxjs';
import { pluck } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';
import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private swalConfig: SweetAlertOptions = {
    confirmButtonText: 'Confirmar',
    showCancelButton: true,
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#7030a0',
    reverseButtons: true,
    heightAuto: false,
    showCloseButton: true,
    customClass: {
      cancelButton: 'Swal__cancelButton',
    },
  };

  constructor(private toastr: ToastrService) {
    const { toastrConfig } = this.toastr;

    toastrConfig.preventDuplicates = true;
    toastrConfig.resetTimeoutOnDuplicate = true;
    toastrConfig.timeOut = 10000;
    toastrConfig.progressBar = true;
  }

  confirm(options: SweetAlertOptions): Observable<boolean> {
    return from(
      //@ts-ignore
      Swal.fire({
        ...this.swalConfig,
        icon: 'question',
        ...options,
      })
    ).pipe(pluck('isConfirmed'));
  }

  prompt(options: SweetAlertOptions): Observable<SweetAlertResult<any>> {
    return from(
      //@ts-ignore
      Swal.fire({
        ...this.swalConfig,
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off',
        },
        ...options,
      })
    );
  }

  success(text: string, title = 'Tudo certo!'): void {
    this.toastr.success(text, title);
  }

  info(text: string, title = 'Informação'): void {
    this.toastr.info(text, title);
  }
}
